import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

import InvitationMessage, { InvalidInvitationMessageError } from "legal-entities/values/invitation-message/invitation-message";

const MessageField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  minWidth: theme.spacing(40)
}));

type MessageInputProps = {
  idPrefix?: string;
  className?: string;
  message?: InvitationMessage;
  onChange?: (message?: InvitationMessage, error?: string) => void;
};

export default function InvitationMessageInput(props: Readonly<MessageInputProps>) {
    const { idPrefix, className, message, onChange } = props;
    const [messageFieldText, setMessageFieldText] = useState<string>(message?.value ?? '');
    const [messageFieldError, setMessageFieldError] = useState<string>('');

  useEffect(() => {
    setMessageFieldText(message?.value ?? '');
  }, [message]);

  function buildMessage(inputText?: string): InvitationMessage | undefined {
    if (!inputText) return;
    
    try {
      return new InvitationMessage(inputText);
    } catch (error) {
      if (error instanceof InvalidInvitationMessageError) {
        console.error(error);
        throw error;
      }
    }
  }

  function handleMessageTextChanged(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setMessageFieldText(event.target.value);

    let newMessage: InvitationMessage | undefined ;
    let newErrors: string = '';

    try {
      newMessage = buildMessage(event.target.value);
      setMessageFieldError('');
    } catch (error) {
      if (!(error instanceof InvalidInvitationMessageError)) return;
      newErrors = error.message;
      setMessageFieldError(newErrors)
    } finally {
      onChange?.(newMessage, newErrors);
    }
  }

  return (
    <MessageField
      id={idPrefix ? idPrefix + "-message-input" : "message-input"}
      className={className}
      label="Message"
      minRows={5}
      multiline
      onChange={handleMessageTextChanged}
      value={messageFieldText}
      error={!!messageFieldError}
      helperText={messageFieldError}
      variant="outlined"
    />
  );
}
